import React, { memo } from 'react';

import SearchList from 'containers/components/SearchList';
import { CAMPAIGNS_TEMPLATES } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

/**
 * Header for the "new template" picker: same search UX as email campaigns (`SearchList` + Redux `matchingName`).
 */
const TemplateSelectorHeader = memo(() => {
    return (
        <div className="fm-entity-menu marketing-templates-selector-header">
            <div className="fm-entity-menu-left marketing-templates-selector-header__left">
                <div className="marketing-templates-selector-header__search">
                    <SearchList
                        className="marketing-templates-selector-header__search-list"
                        entity={CAMPAIGNS_TEMPLATES}
                        placeholder={getLiteral('label_marketing_campaigns_templates_search')}
                        useAsSimpleSearch
                    />
                </div>
            </div>
        </div>
    );
});

TemplateSelectorHeader.displayName = 'TemplateSelectorHeader';

export default TemplateSelectorHeader;
